import { render, staticRenderFns } from "./TeacherProductOrders.vue?vue&type=template&id=f86b82d4"
import script from "./TeacherProductOrders.vue?vue&type=script&lang=js"
export * from "./TeacherProductOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports